// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"banner_upload_thumbnail__3Lr_a","small_thumbnail":"banner_upload_small_thumbnail__3keuX"};